/**
 * R5 — useLearningRules hook.
 * Thin wrapper around /api/learning-rules endpoints.
 */
import { useCallback, useEffect, useState } from "react";
import { api, formatErrorDetail } from "../lib/api";

export default function useLearningRules() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const reload = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const data = await api.learningRulesList();
      setItems(data.items || []);
    } catch (e) {
      setError(formatErrorDetail(e));
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const parseNL = useCallback(async (text) => {
    return api.learningRuleParse(text);
  }, []);

  const create = useCallback(
    async (rule) => {
      const res = await api.learningRuleCreate(rule);
      await reload();
      return res;
    },
    [reload]
  );

  const remove = useCallback(
    async (ruleId) => {
      await api.learningRuleDelete(ruleId);
      await reload();
    },
    [reload]
  );

  return { items, loading, error, reload, parseNL, create, remove };
}
